module.exports = __webpack_public_path__ + "static/media/cloud.508d1f69.svg";